import { render } from "./RoutesList.vue?vue&type=template&id=97d13504&scoped=true"
import script from "./RoutesList.vue?vue&type=script&lang=js"
export * from "./RoutesList.vue?vue&type=script&lang=js"

import "./RoutesList.vue?vue&type=style&index=0&id=97d13504&lang=scss&scoped=true"
import "./RoutesList.vue?vue&type=style&index=1&id=97d13504&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97d13504"]])

export default __exports__